import { Flex, FlexColumn } from 'styles'
import { styled } from '@mui/material'

export const TableListWrap = styled('div')`
  padding: 0 8px;
`

export const TableHeader = styled(Flex)`
  align-items: center;
  border-bottom: 1px solid rgba(46, 54, 59, 1);
  font-weight: 400;
  line-height: 16px;
  position: relative;
  width: 100%;
  padding: 0 8px;
  height: 32px;
`

export const TableHeaderItem = styled(Flex)`
  /* flex: 1; */
  justify-content: flex-start;
  color: rgba(123, 136, 145, 1);
  font-size: 12px;
`

export const TableBody = styled(FlexColumn)`
  overflow-y: auto;
  height: 360px;
  width: 100%;
  ::-webkit-scrollbar {
    height: 2px;
  }
`

export const TableBodyRow = styled(Flex)`
  height: 48px;
  padding: 0 8px;
  flex-shrink: 0;
  position: relative;
  width: 100%;

  border-bottom: 1px solid rgba(46, 54, 59, 1);
  box-sizing: border-box;
  font-size: 14px;

  align-items: center;
  /* ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  } */
  &:hover {
    background-color: rgba(72, 81, 88, 0.5);
  }
  color: ${({ theme }) => theme.color.text100};
`

export const TableBodyRowTd = styled(Flex)`
  /* flex: 1; */
  justify-content: flex-start;
  color: rgba(202, 213, 220, 1);
`

export const MobileCardWrap = styled('div')`
  overflow-y: scroll;
`
